module.exports = __webpack_public_path__ + "static/media/ico-copy-link.6f0e51aa.svg";